import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {BaseModule} from "../../base/base.module";
import {DirectivesModule} from "../../directives/directives.module";

import {TwoFactorComponent} from "./two-factor.component";

@NgModule({
  declarations: [TwoFactorComponent],
  entryComponents: [TwoFactorComponent],
  imports: [
    CommonModule,
    BaseModule,
    DirectivesModule
  ]
})
export class TwoFactorModule {
}
